import Constant from '@/const';
import axios from 'axios';

const deleteGoods = async id => {
  try {
    const response = await axios.delete(
      Constant.apiUrl.concat(`/master/goods/${id}`),
    );
    return response;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default deleteGoods;
